/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
import axios from "axios";
export const useInvoiceEmailStore = defineStore("invoiceEmailStore", {
  state: () => ({
    showUpdateSubjectModal: false,
    showUpdateReminderSubjectModal: false,
    showUpdateLogoModal: false,
    showUpdateIntroModal: false,
    showButtonColorModal: false,
    showAccoucntSummaryModal: false,
    customSubject: "",
    customReminderSubject: "",
    customTrustRequestSubject: "",
    invoiceDelivery: {},
    uploadingImage: false,
    alerts: {},
    subjectOptions: [],
    reminderSubjectOptions: [],
    trustRequestSubjectOptions: [],
    reminderSubjectId: "",
    subjectId: "",
    accountSummary: {},
    qbEmailInfo: {}
  }),
  actions: {
    toggleUpdateSubjectModal(subject, reminderMode) {
      if (reminderMode === "1") {
        this.$patch({
          customReminderSubject: subject,
          showUpdateSubjectModal: !this.showUpdateSubjectModal
        });
        if (subject) {
          if (this.reminderSubjectOptions.length > 5) {
            this.reminderSubjectOptions[0] = {
              label: subject,
              value: subject
            };
          } else {
            this.reminderSubjectOptions.unshift({
              label: subject,
              value: subject
            });
          }
          this.invoiceDelivery.reminderSubjectId = subject;
        }
      } else if (reminderMode === "2") {
        this.$patch({
          customTrustRequestSubject: subject,
          showUpdateSubjectModal: !this.showUpdateSubjectModal
        });
        if (subject) {
          if (this.trustRequestSubjectOptions.length > 5) {
            this.trustRequestSubjectOptions[0] = {
              label: subject,
              value: subject
            };
          } else {
            this.trustRequestSubjectOptions.unshift({
              label: subject,
              value: subject
            });
          }
          this.invoiceDelivery.trustRequestSubjectId = subject;
        }
      } else {
        this.$patch({
          customSubject: subject,
          showUpdateSubjectModal: !this.showUpdateSubjectModal
        });
        if (subject) {
          if (this.subjectOptions.length > 5) {
            this.subjectOptions[0] = {
              label: subject,
              value: subject
            };
          } else {
            this.subjectOptions.unshift({
              label: subject,
              value: subject
            });
          }
          this.invoiceDelivery.subjectId = subject;
        }
      }
    },
    toggleUpdateLogoModal() {
      this.$patch({
        showUpdateLogoModal: !this.showUpdateLogoModal
      });
    },
    toggleUpdateIntroModal() {
      this.$patch({
        showUpdateIntroModal: !this.showUpdateIntroModal
      });
    },
    toggleButtonColorChangeModal() {
      this.$patch({
        showButtonColorModal: !this.showButtonColorModal
      });
    },
    toggleAccountSummaryChangeModal() {
      this.$patch({
        showAccoucntSummaryModal: !this.showAccoucntSummaryModal
      });
    },
    patchImageFromModal(logoUrl) {
      this.$patch({
        invoiceDelivery: {
          logoUrl
        }
      });
    },
    updateFromInfo() {
      this.$patch({
        invoiceDelivery: this.invoiceDelivery
      });
    },
    async sentInvoiceDeliveryDetail(invoiceDeliveryDetail) {
      try {
        const response = await axios({
          url: "/invoicedeliverysettings",
          method: "PUT",
          data: invoiceDeliveryDetail
        });
        this.$patch({
          invoiceDelivery: response.data
        });
        this.alerts.success("Email Settings Updated Successfully");
        return true;
      } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update email settings';
        this.alerts.error(errorMessage);
        return false;
      }
    },
    async getInvoiceDeliveryDetail() {
      if (Object.keys(this.invoiceDelivery).length > 0) {
        return Promise.resolve(this.invoiceDelivery);
      }
      this.$patch({
        loading: true
      });
      try {
        const response = await axios({
          url: "/invoicedeliverysettings",
          method: "GET"
        });
        const {
          subject,
          reminderSubject,
          trustRequestSubject,
          body,
          reminderBody,
          trustRequestBody,
          enabled,
          logoUrl,
          fromEmail,
          fromName,
          modules,
          buttonColor
        } = response.data;
        this.$patch({
          invoiceDelivery: {
            subject,
            reminderSubject,
            trustRequestSubject,
            body,
            reminderBody,
            trustRequestBody,
            enabled,
            updateSubject: subject,
            updateReminderSubject: reminderSubject,
            updateTrustRequestSubject: trustRequestSubject,
            updateBody: body,
            updateReminderBody: reminderBody,
            updateEnabled: enabled,
            updateTrustRequestBody: trustRequestBody,
            logoUrl,
            fromEmail,
            fromName,
            modules,
            buttonColor
          }
        });
        this.$patch({
          loading: false
        });
      } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update logo';
        this.alerts.error(errorMessage);
      }
    },
    async sentImage(img) {
      this.uploadingImage = true;
      try {
        const response = await axios({
          url: "/invoicedeliverysettings/logo",
          method: "PUT",
          data: img,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        this.toggleUpdateLogoModal();
        this.$patch({
          invoiceDelivery: {
            logoUrl: response.data
          }
        });
        this.alerts.success("Logo Updated Successfully");
      } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update logo';
        this.alerts.error(errorMessage);
      } finally {
        this.uploadingImage = false;
      }
    },
    getReminderSubjectOptions(state) {
      return [{
        label: `Reminder: Outstanding Invoice {invoice_number} - ${state.me?.company?.name} Service`,
        value: `Reminder: Outstanding Invoice {invoice_number} - ${state.me?.company?.name} Service`
      }, {
        label: `Reminder: Outstanding Invoice {invoice_number} - ${state.me?.company?.name} Service - {client_name}`,
        value: `Reminder: Outstanding Invoice {invoice_number} - ${state.me?.company?.name} Service - {client_name}`
      }, {
        label: `Reminder: {client_name} - Outstanding Invoice {invoice_number} - ${state.me?.company?.name} Service`,
        value: `Reminder: {client_name} - Outstanding Invoice {invoice_number} - ${state.me?.company?.name} Service`
      }, {
        label: `Reminder: Outstanding Invoice {invoice_number} - ${state.me?.company?.name} Service - {date_due}`,
        value: `Reminder: Outstanding Invoice {invoice_number} - ${state.me?.company?.name} Service - {date_due}`
      }, {
        label: "Customize your own Reminder Subject",
        value: "custom"
      }];
    },
    getSubjectOptions(state) {
      return [{
        label: `Invoice {invoice_number} - ${state.me?.company?.name} Service`,
        value: `Invoice {invoice_number} - ${state.me?.company?.name} Service`
      }, {
        label: `Invoice {invoice_number} - ${state.me?.company?.name} Service - {client_name}`,
        value: `Invoice {invoice_number} - ${state.me?.company?.name} Service - {client_name}`
      }, {
        label: `{client_name} - Invoice {invoice_number} - ${state.me?.company?.name} Service`,
        value: `{client_name} - Invoice {invoice_number} - ${state.me?.company?.name} Service`
      }, {
        label: `Invoice {invoice_number} - ${state.me?.company?.name} Service - {date_due}`,
        value: `Invoice {invoice_number} - ${state.me?.company?.name} Service - {date_due}`
      }, {
        label: "Customize your own Subject",
        value: "custom"
      }];
    },
    getTrustRequestSubjectOptions(state) {
      return [{
        label: `Trust Request - ${state.me?.company?.name} Service`,
        value: `Trust Request - ${state.me?.company?.name} Service`
      }, {
        label: `Trust Request - ${state.me?.company?.name} Service - {client_name}`,
        value: `Trust Request - ${state.me?.company?.name} Service - {client_name}`
      }, {
        label: `{client_name} - Trust Request - ${state.me?.company?.name} Service`,
        value: `{client_name} - Trust Request - ${state.me?.company?.name} Service`
      }, {
        label: `Trust Request - ${state.me?.company?.name} Service - {date_due}`,
        value: `Trust Request - ${state.me?.company?.name} Service - {date_due}`
      }, {
        label: "Customize your own Trust Request Subject",
        value: "custom"
      }];
    },
    getDefaultBody(state) {
      return `Thank you for doing business with ${state.me?.company?.name}. Are there any new problems that our firm can help you with?`;
    },
    getDefaultReminderBody(state) {
      return `Dear {client_name},\n\nWe hope this message finds you well. We are reaching out to remind you about the outstanding invoice #{invoice_number}, due {date_due} . Please review the details below and settle the balance at your earliest convenience.\n\nRegards,\n${state.me?.company?.name}`;
    },
    getDefaultTrustRequestBody(state) {
      return `You have a new trust request from ${state.me?.company?.name}. Amount due: {trust_amount_due}`;
    },
    async getInvoiceDeliverySettings() {
      this.$patch({
        loading: true
      });
      try {
        const response = await axios({
          url: "/invoicedeliverysettings",
          method: "GET",
          params: {
            messageType: 3
          }
        });
        this.$patch({
          loading: false
        });
        return response.data;
      } catch (error) {
        this.alerts?.error(error.message || error.response?.data?.message);
      } finally {
        this.$patch({
          loading: false
        });
      }
    },
    async getQBemailinfo(qbInvoiceId) {
      try {
        const response = await axios({
          url: "/invoices/qbemailinfo",
          method: "GET",
          params: {
            qbInvoiceId
          }
        });
        this.$patch({
          qbEmailInfo: response.data
        });
        return response.data;
      } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to get email info';
        this.alerts.error(errorMessage);
      }
    },
    async getAccountSummary(invoiceId) {
      try {
        const response = await axios({
          url: "/accountsummary",
          method: "GET",
          params: {
            invoiceId
          }
        });
        this.$patch({
          accountSummary: response.data
        });
        const data = response?.data ?? {};
        return data;
      } catch (error) {
        this.alerts?.error(error.message || error.response?.data?.message);
      }
    },
    async testEmail({
      to,
      body,
      timeSheetId
    }) {
      try {
        await axios({
          url: "/TestInvoiceEmail",
          method: "POST",
          data: {
            to,
            timeSheetId,
            subject: body.subject,
            body: body.body,
            modules: body.modules
          }
        });
      } catch (error) {
        this.alerts?.error(error.message || error.response?.data?.message);
      }
    },
    async getInvoiceEmail({
      id
    }) {
      try {
        const response = await axios({
          url: `/invoices/${id}/email`,
          method: "GET"
        });
        return response.data;
      } catch (error) {
        this.alerts?.error(error.message || error.response?.data?.message);
      }
    }
  }
});